import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-selected-background-check',
  templateUrl: './selected-background-check.component.pug',
  styleUrls: ['./selected-background-check.component.scss'],
  standalone: false
})
export class SelectedBackgroundCheckComponent implements OnInit {
  @Input() selectedBackgroundCheck: any;
  @Input() selectedBackgroundChecks: any;
  @Input() selectedFlow: any;
  @Input() selectedFlows: any;
  @Input() disable_edit= false;
  @Output() removeCheck = new EventEmitter();
  ENT_8918_MULTIPLE_BC = false;
  TRUST_752_VERIFICATION = false;
  ent_10605_request_templates = false;

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.ENT_8918_MULTIPLE_BC = this.permissions.isFeatureActivated('ent_8918_multiple_bg_checks');
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
    this.ent_10605_request_templates = this.permissions.isFeatureActivated('ent-10605-request-templates');
  }

  removeSelectedCheck(check) {
    this.removeCheck.emit(check)
  }

  formatData(categories: string[]): string {
    return categories.join(', ');
  }

  getSelectedFlowName(flowId: string): string | null {
    const match = this.selectedFlows.find(f => f.parent_short === flowId);
    return match ? match.name : null;
  }



}
